import React from 'react'
import HVTRegistrationListComponent from '../Components/HVTRegistration/HVTRegistrationListComponent'

const HVTRegistrationListPage = () => {
  return (
    <HVTRegistrationListComponent />
  )
}

export default HVTRegistrationListPage